export const TipoContenido = {
  Standar: 0,
  UploadFile: 1,
  TemplateWork: 2,
  MergeDocument: 3,
  TemplateWorkMergeDocument: 4,
  MergeFileToPdf: 5,
};

export const TipoDetalleDocumentos = {
  Predefinida: 1,
  Reporte: 2,
  ServicioRutina: 3,
  LLave: 4,
};